// extracted by mini-css-extract-plugin
export default {"container":"LXDropzone_container__LBZqC"};